import React, { useState, useEffect, useCallback,useRef } from "react";
import { connect } from "react-redux";
import axios from "axios";
import data from "../../../../assets/apiRoutes.json";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
const LocationsPopup = (props) => {
  const dataGrid = useRef(null);
  const [popupState, setPopUpState] = useState(props.visibility);
  const[noDataText, setNoDataText]= useState("Loading Data ...");
  const [locationData, setLocationData] = useState([]);
  const [inventoryItemLocationCodesObj, setInventoryItemLocationCodesObj] = useState({
    lotCode: "",
    itemCode: "",
    lotRowid: props.itemObj.lotRowid,
    itemRowid:props.itemObj.itemRowid,
    subLotRowid: props.itemObj.subLotRowid
  });
  var accessToken = props.oidc.user.access_token;
  const columns = ['ItemCode', 'Description-1', 'Description-2', 'Status', 'Class', 'SubClass'];
  const dataItmGrid = [{'ItemCode': props.itemObj.itemCode, 'Description-1': props.itemObj.itemDescription1, 'Description-2': props.itemObj.itemDescription2 ,
                'Status': props.itemObj.itemStatus, 'Class': props.itemObj.classCode, 'SubClass': props.itemObj.subClassCode}];

  const hideInfo = () => {
    setPopUpState(false);
    props.parentCallback(false);
  };

  useEffect(() => {
    loadInventoryLocationData();
  }, []);
  const loadInventoryLocationData = () => {
    setNoDataText("Loading Data ...");
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.Location.GetLocationsByItemId}`, inventoryItemLocationCodesObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        setLocationData(res.data);
        if(res.data.length == 0)
        {
          setNoDataText("No Data");
        }
      });
  };

  const gridKey = "626d4916-ed14-46d5-b2ab-68312e4f4457";
  const [currentLayout, setCurrentLayout]= useState("Default");
  const loadState =  useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout, gridKey, accessToken]);
  const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout, accessToken]);
  

  return(
    <Popup
      //visible={props.visibility}
      visible={popupState}
      onHiding={hideInfo}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="Locations"
      //container=".inventory-container"
      container="#root"
      className="custom-popup"
      >

      {/* Item Grid */}
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        dataSource={dataItmGrid}
        defaultColumns={columns}
        showBorders={true}
      />
      {/* Locations Grid */}
      <div className="row">
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
          noDataText={noDataText}
          dataSource={locationData}
          showBorders={true}
          className="popupGrid-height"
          hoverStateEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
          scrolling={{ mode: "standard" }}
        >
          <ColumnChooser enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <ColumnHeaderFilter />
          <Sorting visible={true}  mode="multiple" />
          <LoadPanel enabled={true} />
          <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={[5, 10, 20, "all"]}
            showNavigationButtons={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <GroupPanel visible={true} />
          <Grouping autoExpandAll={false} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={loadState}
            storageKey={gridKey}
            customSave={saveState}
          />
          <Column dataField="locationWareHousIdentityCode" caption="Warehouse"></Column>
          <Column dataField="locationCode" caption={Localization.formatMessage('IMLOCATION.LOCATIONCODE', 'Location')} ></Column>
          <Column dataField="locOnHand" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.ON_HAND', 'On Hand')}></Column>
          <Column dataField="locInReceiving" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_RECEIVING', 'In Receiving')}></Column>
          <Column dataField="locShipping" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_SHIPPED', 'In Shipping')}></Column>
          <Column dataField="locAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.AVAILABLE', 'Available')}></Column>
          <Column dataField="locPendingRec" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_FUTURE', 'Pending Rec')} ></Column>
          <Column dataField="locPendingShip" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_FUTURE', 'Pending Ship')}></Column>
          <Column dataField="locNetAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.NETAVAILABLE', 'Net Available')} ></Column>
          <Toolbar>
            <Item location="after">
              <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </div>
    </Popup>
  )
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationsPopup);